/**
 * Scrollable table helper
 *
 */
const initScrollableTable = () => {
  const tableWrappers = [
    ...document.querySelectorAll('.c-editor-content .table-wrapper'),
  ];

  if (!tableWrappers.length) return;
  const TABLE_SCROLLABLE_HINT_CLASS = 'table-is-scrollable-hint';

  tableWrappers.forEach(tableWrapper => {
    const table = tableWrapper.querySelector('table');
    // Check if the table has an overflow
    const tableHasOverflow = table.offsetWidth > tableWrapper.offsetWidth;
    if (!tableHasOverflow) return;
    // If the table has an overflow show a hint icon to indicate the user to scroll horizontal
    const scrollHint = document.createElement('span');
    scrollHint.classList.add(TABLE_SCROLLABLE_HINT_CLASS);
    // Insert the scroll hint directly after the table-wrapper
    tableWrapper.parentNode.insertBefore(scrollHint, tableWrapper.nextSibling);
  });
};

initScrollableTable();
